import { groq } from "next-sanity";
import { sanityFetch } from "@otomoro/sanity/lib/sanity.fetch";

export const latestNewsQuery = groq`*[_type == "newsPages" && slug.current != $slug] | order(publishedAt desc) [0...3]  {
  title,
  publishedAt,
  image{
    ...,
    "lqip": asset->metadata.lqip
  },
  duration,
  thumbnail{
    ...,
    "lqip": asset->metadata.lqip
  },
  "slug": slug.current,
  newsType->{
    title
  }
}`;
